import { createAction, props } from '@ngrx/store';
import { MappedHttpErrorResponse } from '@adnova/jf-ng-components';
import {
  AnnouncementCreateDTO,
  AnnouncementUpdateDTO,
  DirectionDTO,
  ProblemDTO,
} from '../../../openapi/shell-service-openapi';

/**
 * Actions für das Admin-Announcement Dashboard.
 */
export class AdminAnnouncementActions {
  private static readonly prefix = '[Admin Announcement]';

  /**
   * Initialisiert das Dashboard.
   * Lädt Announcements und Statistiken.
   */
  static init = createAction(
    `${this.prefix} Init`,
  );

  /**
   * Setzt die Pagination-Parameter.
   */
  static setPage = createAction(
    `${this.prefix} Set Page`,
    props<{ pageIndex: number; pageSize: number }>(),
  );

  /**
   * Setzt die Sortier-Parameter.
   * Setzt pageIndex auf 0 (neue Sortierung → erste Seite).
   */
  static setSort = createAction(
    `${this.prefix} Set Sort`,
    props<{ sortProperties: string[]; sortDirections: DirectionDTO[] }>(),
  );

  /** Öffnet den Editor im Erstellen-Modus. */
  static openCreate = createAction(
    `${this.prefix} Open Create`,
  );

  /** Öffnet den Editor im Bearbeiten-Modus für ein bestehendes Announcement. */
  static openEdit = createAction(
    `${this.prefix} Open Edit`,
    props<{ id: string }>(),
  );

  /** Schließt den Editor und kehrt zum Dashboard zurück. */
  static closeEditor = createAction(
    `${this.prefix} Close Editor`,
  );

  /** Öffnet das Info-Popup als Vorschau für ein bestehendes Announcement. */
  static previewAnnouncement = createAction(
    `${this.prefix} Preview Announcement`,
    props<{ id: string }>(),
  );

  /** Speichert ein neues Announcement als Entwurf. */
  static saveAsDraft = createAction(
    `${this.prefix} Save As Draft`,
    props<{ dto: AnnouncementCreateDTO }>(),
  );

  /** Speichert ein neues Announcement und veröffentlicht es direkt. */
  static saveAndPublish = createAction(
    `${this.prefix} Save And Publish`,
    props<{ dto: AnnouncementCreateDTO }>(),
  );

  /** Aktualisiert ein bestehendes Announcement. */
  static updateAnnouncement = createAction(
    `${this.prefix} Update Announcement`,
    props<{ id: string; dto: AnnouncementUpdateDTO }>(),
  );

  /** Aktualisiert ein bestehendes Announcement und veröffentlicht es anschließend. */
  static updateAndPublish = createAction(
    `${this.prefix} Update And Publish`,
    props<{ id: string; dto: AnnouncementUpdateDTO }>(),
  );

  /** Speichern erfolgreich. */
  static saveSuccess = createAction(
    `${this.prefix} Save Success`,
  );

  /** Fehler beim Speichern. */
  static saveFailure = createAction(
    `${this.prefix} Save Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );
}
